module.exports = __webpack_public_path__ + "img/pog_cyclone.85e33508.png";